"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ = require("./");

class EvaluatorTrainingData {
  static thaw(evaluatorTrainingDataObj) {
    if (evaluatorTrainingDataObj == null) return null;
    const evaluatorTrainingData = new EvaluatorTrainingData();
    if (evaluatorTrainingDataObj.id != null) evaluatorTrainingData.setId(evaluatorTrainingDataObj.id);
    if (evaluatorTrainingDataObj.key != null) evaluatorTrainingData.setKey(evaluatorTrainingDataObj.key);
    if (evaluatorTrainingDataObj.value != null) evaluatorTrainingData.setValue(evaluatorTrainingDataObj.value);
    if (evaluatorTrainingDataObj.evaluatorId != null) evaluatorTrainingData.setEvaluatorId(evaluatorTrainingDataObj.evaluatorId);
    if (evaluatorTrainingDataObj.trainingModuleId != null) evaluatorTrainingData.setTrainingModuleId(evaluatorTrainingDataObj.trainingModuleId);
    if (evaluatorTrainingDataObj.evaluator != null) evaluatorTrainingData.setEvaluator(_.Evaluator.thaw(evaluatorTrainingDataObj.evaluator));
    if (evaluatorTrainingDataObj.trainingModule != null) evaluatorTrainingData.setTrainingModule(_.TrainingModule.thaw(evaluatorTrainingDataObj.trainingModule));
    return evaluatorTrainingData;
  }

  static thawList(evaluatorTrainingDataObjList) {
    if (evaluatorTrainingDataObjList == null) return [];
    var evaluatorTrainingDatas = [];

    for (var i = 0; i < evaluatorTrainingDataObjList.length; i++) {
      evaluatorTrainingDatas.push(EvaluatorTrainingData.thaw(evaluatorTrainingDataObjList[i]));
    }

    return evaluatorTrainingDatas;
  }

  static freeze(evaluatorTrainingData) {
    if (evaluatorTrainingData == null) return null;
    var evaluatorTrainingDataObj = {};
    if (evaluatorTrainingData.getId() != null) evaluatorTrainingDataObj.id = evaluatorTrainingData.getId();
    if (evaluatorTrainingData.getKey() != null) evaluatorTrainingDataObj.key = evaluatorTrainingData.getKey();
    if (evaluatorTrainingData.getValue() != null) evaluatorTrainingDataObj.value = evaluatorTrainingData.getValue();
    if (evaluatorTrainingData.getEvaluatorId() != null) evaluatorTrainingDataObj.evaluatorId = evaluatorTrainingData.getEvaluatorId();
    if (evaluatorTrainingData.getTrainingModuleId() != null) evaluatorTrainingDataObj.trainingModuleId = evaluatorTrainingData.getTrainingModuleId();
    if (evaluatorTrainingData.getEvaluator() != null) evaluatorTrainingDataObj.evaluator = _.Evaluator.freeze(evaluatorTrainingData.getEvaluator());
    if (evaluatorTrainingData.getTrainingModule() != null) evaluatorTrainingDataObj.trainingModule = _.TrainingModule.freeze(evaluatorTrainingData.getTrainingModule());
    return evaluatorTrainingDataObj;
  }

  static freezeList(evaluatorTrainingDatas) {
    if (evaluatorTrainingDatas == null) return [];
    var evaluatorTrainingDataObjList = [];

    for (var i = 0; i < evaluatorTrainingDatas.length; i++) {
      evaluatorTrainingDataObjList.push(EvaluatorTrainingData.freeze(evaluatorTrainingDatas[i]));
    }

    return evaluatorTrainingDataObjList;
  }

  constructor() {
    this.setId(null);
    this.setKey(null);
    this.setValue(null);
    this.setEvaluatorId(null);
    this.setTrainingModuleId(null);
    this.setEvaluator(null);
    this.setTrainingModule(null);
  }
  /* -------------------------
     -------------------------
     -------- SETTERS --------
     -------------------------
     ------------------------- */


  setId(id) {
    this.id = id;
  }

  setKey(key) {
    this.key = key;
  }

  setValue(value) {
    this.value = value;
  }

  setEvaluatorId(evaluatorId) {
    this.evaluatorId = evaluatorId;
  }

  setTrainingModuleId(trainingModuleId) {
    this.trainingModuleId = trainingModuleId;
  }

  setEvaluator(evaluator) {
    this.evaluator = evaluator;
  }

  setTrainingModule(trainingModule) {
    this.trainingModule = trainingModule;
  }
  /* -------------------------
     -------------------------
     -------- GETTERS --------
     -------------------------
     ------------------------- */


  getId() {
    return this.id;
  }

  getKey() {
    return this.key;
  }

  getValue() {
    return this.value;
  }

  getEvaluatorId() {
    return this.evaluatorId;
  }

  getTrainingModuleId() {
    return this.trainingModuleId;
  }

  getEvaluator() {
    return this.evaluator;
  }

  getTrainingModule() {
    return this.trainingModule;
  }
  /* -------------------------
     -------------------------
     -------- HELPERS --------
     -------------------------
     ------------------------- */


}

exports.default = EvaluatorTrainingData;